/**
 * External dependencies
 */
import React, { useState, useEffect } from 'react';

/**
 * Internal dependencies
 */
import Preloader from 'components/preloader';
//import NewPlanEstimate from 'modules/me/new-plan-estimate';
import Modal from 'components/modal';
import { Stack, TowerProvider, Box, Heading } from '@towersystems/towersystems-design-system';
import Button from 'components/button';
import ButtonGroup from 'components/button-group';
import DropdownSelect from 'components/dropdown-select';
import FormTextInput from 'components/forms/form-text-input';
import FormLabel from 'components/forms/form-label';
import FormSelect from 'components/forms/form-select';

/**
 * Style dependencies
 */
import './styles.scss';

// this was originally written as a dialog; make it look like a modal.. to be consistent with
// everything else
//
const ConfirmNewPlanAlert = ({ onClose, onSubmit, ...rest }) => {
	const [submitting, setSubmitting] = useState(false);
	return (
		<TowerProvider>
			<Modal close={false} isVisible={true} header={false} className='confirm-new-plan-modal'>
				{submitting && <Preloader />}
				<Box
					padding='xxlarge'

					display='flex'
					flexDirection='column'
					justifyContent='spaceBetween'
				>
                    <FormLabel>Select a plan:</FormLabel>
						<FormSelect name='groupCode' >
							<option value='' />
							<option >
							    Dispatch Module
							</option>
							<option >
								Customer Self Checkout
							</option>
							<option >
								Shopify Website 14 Month Repayment
							</option>
							<option >
								Barcode Lookup Module
							</option>
							<option >
								Roam
							</option>
							<option >
								Cloud Backup
							</option>
						</FormSelect>
				</Box>
                <Box>
 					<ButtonGroup alignItems='center' justifyContent='center'>
						<Button disabled={submitting} className='btn' onClick={onClose}>
							Cancel
						</Button>
						<Button
							disabled={submitting}
							primary
							onClick={() => {
								setSubmitting(false);
								return onSubmit()
									.then(() => onClose())
									.catch((error) => console.log(error))
									.finally(() => {
										setSubmitting(false);
									});
							}}
						>
							Select the plan
						</Button>
					</ButtonGroup>
				</Box>
			</Modal>
		</TowerProvider>
	);
};

export default ConfirmNewPlanAlert;
